module.exports = __webpack_public_path__ + "videos/3d-model_cn.bd49084.webm";